// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".echarts-pie[data-v-294cc4eb] {\n  width: 100%;\n  height: 400px;\n}\n", ""]);
// Exports
module.exports = exports;
